import { State } from '../../../types/state';
import { GoogleMapsStatus } from '../../../types/map/maps';

export const googleMapsStatusSelector = (state:State):GoogleMapsStatus => {
    return state.system.googleMapsStatus || GoogleMapsStatus.PENDING;
}
